import { map } from 'rxjs';
import { isEmpty } from 'lodash';
import { Injectable } from '@angular/core';
import { AsyncValidatorFn, FormArray, FormControl, FormGroup } from '@angular/forms';
import { DeviceUserFormControlName, MyDeviceFormControlName } from '../models';
import {
  MyDevicesFormBuilderService,
  MyDevicesFormState
} from '../types/my-devices-form-builder-service.type';
import { DeviceUser } from '@core/models/device-user';

@Injectable({
  providedIn: 'any'
})
export class RegisteredDevicesFormService implements MyDevicesFormBuilderService {
  constructor() {}

  initForm(devices: DeviceUser[] | undefined, formState: MyDevicesFormState): FormGroup {
    if (!devices?.length) {
      return new FormGroup({
        [MyDeviceFormControlName.REGISTERED_DEVICES]: new FormArray([]),
        [MyDeviceFormControlName.NEW_DEVICES]: new FormArray([])
      });
    }

    return new FormGroup({
      [MyDeviceFormControlName.REGISTERED_DEVICES]: new FormArray(
        this.buildDeviceFormGroups(devices)
      ),
      [MyDeviceFormControlName.NEW_DEVICES]: new FormArray([])
    });
  }

  configureForm(form: FormGroup) {
    if (!form) {
      return;
    }

    const devicesFormArray: FormArray = form.get(
      MyDeviceFormControlName.REGISTERED_DEVICES
    ) as FormArray;
    devicesFormArray?.controls.forEach((control) => {
      const serialFormControl = control.get(DeviceUserFormControlName.SERIAL);
      if (serialFormControl) {
        serialFormControl.disable();
      }
    });
  }

  private buildDeviceFormGroups(devices: DeviceUser[] | undefined): FormGroup[] {
    if (!devices || isEmpty(devices)) {
      return [this.buildSerialFormControlForDevices()];
    }

    return devices!.map((device) => this.buildSerialFormControlForDevices(device));
  }

  private buildSerialFormControlForDevices(device?: DeviceUser): FormGroup {
    const serialFormControl = new FormControl(device?.serial);
    serialFormControl.disable();

    const passphraseFormControl =
      device && !!device.passphrase ? new FormControl(device?.passphrase) : null;

    const deviceFormGroup: FormGroup = new FormGroup({
      [DeviceUserFormControlName.SERIAL]: serialFormControl
    });

    if (passphraseFormControl) {
      passphraseFormControl.disable();
      deviceFormGroup.addControl(DeviceUserFormControlName.PASSPHRASE, passphraseFormControl);
    }

    return deviceFormGroup;
  }
}
